"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("../../../../extends-fa579b0f.js"),
  t = require("../../../../objectWithoutProperties-2581b642.js"),
  r = require("../../../../getPrototypeOf-6e942d92.js"),
  n = require("react"),
  o = require("classnames");
function c(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
require("../../../../_commonjsHelpers-f10b257f.js"), require("../../../../toPropertyKey-ec4a2a72.js");
var l = c(n),
  s = c(o),
  a = ["className", "svgRef"];
function u(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      o = r._getPrototypeOf(e);
    if (t) {
      var c = r._getPrototypeOf(this).constructor;
      n = Reflect.construct(o, arguments, c);
    } else n = o.apply(this, arguments);
    return r._possibleConstructorReturn(this, n);
  };
}
var i = function (n) {
  r._inherits(c, n);
  var o = u(c);
  function c() {
    return r._classCallCheck(this, c), o.apply(this, arguments);
  }
  return r._createClass(c, [{
    key: "render",
    value: function value() {
      var r = this.props,
        n = r.className,
        o = r.svgRef,
        c = t._objectWithoutProperties(r, a);
      return l["default"].createElement("svg", e._extends({
        width: "37",
        height: "38",
        viewBox: "0 0 37 38",
        fill: "currentColor",
        className: s["default"]("nmx-icon", n),
        ref: o
      }, c), l["default"].createElement("g", {
        fill: "none",
        transform: "translate(.5 .775)",
        fillRule: "evenodd"
      }, l["default"].createElement("circle", {
        cx: "18.144",
        cy: "18.144",
        r: "18.144",
        fill: "#1570BC",
        className: "icon-fill"
      }), l["default"].createElement("g", {
        stroke: "#FFF",
        className: "icon-color",
        strokeWidth: "3.456",
        strokeLinecap: "square"
      }, l["default"].createElement("path", {
        d: "M18.25 11.54v13.479M25.738 17.885h-15.24"
      }))));
    }
  }]), c;
}(l["default"].PureComponent);
i.displayName = "PlusSignFillIcon", module.exports = i;